export default __webpack_public_path__ + "static/media/card-w-about.6e19b662.png";